import { render, staticRenderFns } from "./AccepterUserRegistration.vue?vue&type=template&id=c9bcec9e&"
import script from "./AccepterUserRegistration.vue?vue&type=script&lang=ts&"
export * from "./AccepterUserRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports